

import {Options, Vue} from "vue-class-component"
import Channel from "@/model/directory/Channel"
import {projectServiceApi} from "@/api/ProjectServiceApi"
import {channelServiceApi} from "@/api/ChannelServiceApi"
import Skeleton from "primevue/skeleton"
import User from "@/model/User"
import {userServiceApi} from "@/api/UserServiceApi"
import {rpcClient} from "@/api/WebsocketClient"
import SWR from "@/api/SWR"
import Project from "@/model/directory/Project"
import InfiniteList from "@/components/common/InfiniteList.vue"
import {Language, useGettext} from "@jshmrtn/vue3-gettext"

@Options({
  components: { Skeleton, InfiniteList  },
  //@ts-ignore
  props: {},
  emits: []
})
export default class ChatWidget extends Vue {

  projectsAreLoading: boolean = false
  channelsAreLoading: boolean = false
  usersAreLoading: boolean = false
  channelApi = channelServiceApi
  i18n: Language = useGettext()

  get loading(): boolean {
    return this.channelsAreLoading || this.usersAreLoading || this.projectsAreLoading
  }

  goToItem(item: Channel): void {
    if (item.id) {
      void this.$router.push('/chat/' + encodeURIComponent(item.id))
    }
  }

  get projects() {
    const swr: SWR<Project[], string[]> = projectServiceApi.getProjects()
    if (swr.call?.loading && swr.call?.promise) {
      this.projectsAreLoading = true
      swr.call.promise.finally(() => { this.projectsAreLoading  = false })
    }
    return swr.data || []
  }

  get currentProjectId(): string | null {
    if (this.projects && this.projects.length > 0) {
      return this.projects[0].id
    } else {
      return null
    }
  }

  get channels(): Channel[] {
    const channels = []
    let swr1 = this.channelApi.getChannelsForTeam(this.currentProjectId || null, false)
    let swr2 = this.currentProjectId ? this.channelApi.getChannelsForTeam(null, false) : undefined
    this.channelsAreLoading = Boolean((swr1.call?.loading && swr1.call?.promise) || (swr2?.call?.loading && swr2?.call?.promise))
    if (swr1.call?.promise) {
      swr1.call.promise.finally(() => {
        if (!swr2?.call?.loading || !swr2?.call?.promise) {
          this.channelsAreLoading = false
        }
      })
    }
    if (swr2?.call?.promise) {
      swr2.call.promise.finally(() => {
        if (!swr1?.call?.loading || !swr1?.call?.promise) {
          this.channelsAreLoading = false
        }
      })
    }
    if (swr1.data && (!swr2 || swr2.data)) {
      channels.push(...swr1.data)
      if (swr2?.data) channels.push(...swr2.data.filter(c => c.isDirect))
    }
    return channels.filter(c => !c.deleted)
  }

  get allItems(): Channel[] {
    return this.channels.filter((ch: Channel) => {
      return ch.unreadMsgCount ? ch.unreadMsgCount > 0 : false
    })
  }

  get unreadMessageCnt(): number {
    let sum = 0
    this.allItems.forEach((ch: Channel) => {
      sum += ch.unreadMsgCount || 0
    })
    return sum
  }

  get users(): User[] {
    const swr = userServiceApi.getUsers()
    if (swr.call?.loading && swr.call?.promise) {
      this.usersAreLoading = true
      swr.call.promise.finally(() => {
        this.usersAreLoading = false
      })
    }
    return swr.data || []
  }

  getChannelName(channel: Channel): string {
    if (channel.type === "Direct") {
      return this.getChannelNameForDirectConversation(channel)
    } else {
      return channel.displayName || ""
    }
  }

  getChannelNameForDirectConversation(channel: Channel): string {
    const username = rpcClient.session.user?.userName
    const users: string[] = []
    channel.members?.forEach((member: string ) => {
      if (member !== username) {
        const user: User | undefined = userServiceApi.getUser(member)
        if (!user) {
          users.push(member)
        } else {
          users.push(user.displayName || member)
        }
      }
    })

    return users.join(", ")
  }


}
